import ENDPOINTS from '@/config/http/endpoints'
import { rootApi } from '@/ducks/root.api'
import {
  ApiFetchAllStoreBranches,
  ApiFetchStoreBranches,
  ApiGetStoreAvailability,
  ApiGetStoreBusyStatus,
  ApiUpdateStoreBusyStatus,
  ApiGetStoreProfile,
  StoreMarketingProfile
} from '@/ducks/store/store.types'

export const storeApi = rootApi.injectEndpoints({
  endpoints: build => ({
    changeStoreAvailability: build.mutation<
      { message: string },
      {
        store_id: string
        availability: number
      }
    >({
      query: data => ({
        method: 'POST',
        url: ENDPOINTS.TOGGLE_AVAILABILITY,
        data
      })
    }),
    fetchStoreProfile: build.mutation<
      ApiGetStoreProfile,
      {
        store_id: string
      }
    >({
      query: data => ({
        method: 'POST',
        url: ENDPOINTS.GET_STORE_INFO,
        data
      })
    }),
    getStoreMarketingProfile: build.query<StoreMarketingProfile, void>({
      query: () => ({
        method: 'GET',
        url: ENDPOINTS.GET_STORE_PROFILE_V31
      }),
      transformResponse: (response: {
        profileData?: { store_link?: string; unique_code?: string }
      }): StoreMarketingProfile => ({
        storeLink: response?.profileData?.store_link?.trim() || null,
        uniqueCode: response?.profileData?.unique_code?.trim() || null
      })
    }),
    fetchStoreAvailability: build.query<
      ApiGetStoreAvailability,
      {
        store_id: string
      }
    >({
      query: ({ store_id }) => ({
        method: 'GET',
        url: ENDPOINTS.FETCH_AVAILABILITY(store_id)
      })
    }),
    fetchStoreBranches: build.query<ApiFetchStoreBranches, void>({
      providesTags: [{ type: 'Menu', id: 'LIST' }],
      query: () => ({
        method: 'GET',
        url: ENDPOINTS.GET_STORE_BRANCHES
      })
    }),
    fetchAllStoreBranches: build.query<ApiFetchAllStoreBranches, void>({
      providesTags: [{ type: 'Menu', id: 'LIST' }],
      query: () => ({
        method: 'GET',
        url: ENDPOINTS.GET_ALL_STORE_BRANCHES
      })
    }),
    setBranchAvailability: build.mutation<
      { message: string },
      { store_id: string; availability: number }
    >({
      query: (data) => ({
        method: 'POST',
        url: ENDPOINTS.SET_BRANCH_AVAILABILITY,
        data
      }),
      invalidatesTags: [{ type: 'Menu', id: 'LIST' }]
    }),
    getStoreBusyStatus: build.query<ApiGetStoreBusyStatus, void>({
      query: () => ({
        method: 'GET',
        url: ENDPOINTS.GET_STORE_BUSY_STATUS
      })
    }),
    updateStoreBusyStatus: build.mutation<
      { message: string },
      ApiUpdateStoreBusyStatus
    >({
      query: (data) => ({
        method: 'PATCH',
        url: ENDPOINTS.UPDATE_STORE_BUSY_STATUS,
        data
      })
    })
  })
})

export const {
  useChangeStoreAvailabilityMutation,
  useFetchStoreProfileMutation,
  useGetStoreMarketingProfileQuery,
  useFetchStoreAvailabilityQuery,
  useFetchStoreBranchesQuery,
  useFetchAllStoreBranchesQuery,
  useSetBranchAvailabilityMutation,
  useGetStoreBusyStatusQuery,
  useUpdateStoreBusyStatusMutation
} = storeApi

export default storeApi
